import { render, staticRenderFns } from "./PopupNotificationComponent.vue?vue&type=template&id=2251ae51&scoped=true"
import script from "./PopupNotificationComponent.vue?vue&type=script&lang=js"
export * from "./PopupNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupNotificationComponent.vue?vue&type=style&index=0&id=2251ae51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251ae51",
  null
  
)

export default component.exports